import {createAction} from 'redux-actions';

import {OSM, Region} from './actions';

/**
 * @param {String} layer
 */
export const changeLayer = createAction(OSM.Layer);

/**
 * @param {Boolean} colored
 */
export const changeColored = createAction(OSM.Colored);

/**
 * @param {Number} opacity
 */
export const changeOpacity = createAction(OSM.Opacity);

/**
 * @param {Boolean} enabled
 */
export const changeFAIEnabled = createAction(OSM.FAI);

const confirmRegionChangeAction = createAction(Region.confirmChange);

export const confirmRegionChange = id => (dispatch, getState) => {
    const {confirmRegionChange} = getState();

    if (confirmRegionChange) confirmRegionChange.confirm(false);

    return new Promise(resolve => {
        dispatch(confirmRegionChangeAction({
            id,
            confirm: abort => {
                resolve(abort);
                dispatch(confirmRegionChangeAction(null));
            },
        }));
    });
};
